// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__35An9","input_btn":"SearchBar_input_btn__3nTWG"};